module.exports = __webpack_public_path__ + "static/media/speaker_head_expressions_face_right.a5e4bb67.png";